import { render, staticRenderFns } from "./accreditRegister.vue?vue&type=template&id=b1262974&scoped=true&"
import script from "./accreditRegister.vue?vue&type=script&lang=js&"
export * from "./accreditRegister.vue?vue&type=script&lang=js&"
import style0 from "./accreditRegister.vue?vue&type=style&index=0&id=b1262974&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1262974",
  null
  
)

export default component.exports